import { Directive, HostListener, Input, inject } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Directive({
    selector: '[appNgbDropdownOnHover]',
    standalone: false,
})
export class NgbDropdownOnHoverDirective {
    public dropdown = inject(NgbDropdown);

    @Input() public dropdowns: NgbDropdown[];
    @Input() public isExpanded: boolean;

    @HostListener('mouseenter')
    public onMouseEnter() {
        for (let d of this.dropdowns) {
            if (d !== this.dropdown && d.isOpen()) {
                d.close();
            }
        }

        if (!this.isExpanded) {
            this.dropdown.open();
        }
    }

    @HostListener('click')
    public onClick() {
        this.dropdown.close();
    }

    constructor() {
        this.dropdown.autoClose = true;
    }
}
